import angular from 'angular'

import invoiceBiduleProofOfResidence from './component/invoiceBiduleProofOfResidence'
import invoiceBiduleSleek from './component/invoiceBiduleSleek'
import invoiceDetail from './component/invoiceDetail'
import invoiceDetails from './component/invoiceDetails'
import invoiceSituation from './component/invoiceSituation'
import invoiceSituationTimeline from './component/invoiceSituationTimeline'
import invoiceCtrl from './invoice'
import invoicePaymentTable from './component/invoicePaymentTable'

/* Angular styleguide https://github.com/toddmotto/angular-styleguide */
export default angular
.module('unergie.invoice', [])
.directive('invoiceBiduleProofOfResidence', invoiceBiduleProofOfResidence)
.component('invoiceBiduleSleek', invoiceBiduleSleek)
.directive('invoiceDetail', invoiceDetail)
.directive('invoiceDetails', invoiceDetails)
.directive('invoiceSituation', invoiceSituation)
.directive('invoiceSituationTimeline', invoiceSituationTimeline)
.controller('invoiceCtrl', invoiceCtrl)
.component('invoicePaymentTable', invoicePaymentTable)
.name



// WEBPACK FOOTER //
// ./src/states/invoice/invoice.module.js